import { render, staticRenderFns } from "./ContactContent.vue?vue&type=template&id=8aaeff48&scoped=true&"
import script from "./ContactContent.vue?vue&type=script&lang=js&"
export * from "./ContactContent.vue?vue&type=script&lang=js&"
import style0 from "./ContactContent.vue?vue&type=style&index=0&id=8aaeff48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaeff48",
  null
  
)

export default component.exports